export default __webpack_public_path__ + "static/media/ic_success.1e4af21e.svg";